import {createAsyncThunk, createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {toast} from "react-toastify";
import {
    addFitModelApi, deleteFitModelApi,
    getFitModelApi,
    updateFitModelApi
} from "../../../services/manage-product/setting/fitModelService";


export const getAllFitModels = createAsyncThunk('fitModel/getFitModel', async (filters, {dispatch}) => {
    const response = await getFitModelApi(filters);
    return response.response;
});

const buildFitModelFormData = (data) => {
    const formData = new FormData();
    formData.append('name', data.name);
    if (data.profile_image && data.profile_image.length > 0) {
        formData.append('profile_image', data.profile_image[0]);
    }
    return formData;
};

export const addFitModel = createAsyncThunk('fitModel/addFitModel', async (fitModel, {
    dispatch,
    getState
}) => {
    try {
        const response = await addFitModelApi(buildFitModelFormData(fitModel));
        const data = await response.response;
        dispatch(getAllFitModels());
        toast.success("Add fit model successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return data;
    } catch (e) {

        return Promise.reject(e);
    }
});

export const updateFitModel = createAsyncThunk('fitModel/updateFitModel', async (fitModel, {
    dispatch,
    getState
}) => {
    try {
        const response = await updateFitModelApi(buildFitModelFormData(fitModel), fitModel.id);
        const data = await response.response;
        dispatch(getAllFitModels());
        toast.success("Update fit model successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return data;
    } catch (e) {

        return Promise.reject(e);
    }
});

export const deleteFitModel = createAsyncThunk('fitModel/deleteFitModel', async (id, {
    dispatch,
    getState
}) => {
    try {
        const response = await deleteFitModelApi(id);
        const data = await response.response;
        dispatch(getAllFitModels());
        toast.success("Delete fit model successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return data;
    } catch (e) {

        return Promise.reject(e);
    }
});

const fitModelAdapter = createEntityAdapter({});

export const {selectAll: selectFitModel, selectById: selectFitModelById} = fitModelAdapter.getSelectors(
    state => state.product.fitModel
);

const fitModelSlice = createSlice({
    name: 'fitModel',
    initialState: fitModelAdapter.getInitialState({
        searchText: '',
        addDialog: {
            component: 'fitModel',
            type: 'new',
            props: {
                open: false
            },
            data: null
        },
    }),
    reducers: {
        selectFitModelSearchText: {
            reducer: (state, action) => {
                state.searchText = action.payload;
            },
            prepare: event => ({payload: event.target.value || ''})
        },
        openNewDialog: (state, action) => {
            state.addDialog = {
                component: 'fitModel',
                type: 'new',
                props: {
                    isOpen: true
                },
                data: null
            };
        },
        openEditDialog: (state, action) => {
            state.addDialog = {
                type: 'edit',
                props: {
                    isOpen: true
                },
                data: action.payload
            };
        },
        closeEditDialog: (state, action) => {
            state.addDialog = {
                type: 'edit',
                props: {
                    isOpen: false
                },
                data: null
            };
        },
    },
    extraReducers: {
        [getAllFitModels.fulfilled]: fitModelAdapter.setAll
    }
});

export const {
    selectFitModelSearchText, openNewDialog,
    closeNewDialog,
    openEditDialog,
    closeEditDialog
} = fitModelSlice.actions;

export default fitModelSlice.reducer;
